import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { take } from 'rxjs/operators';
import { CallAgentService } from 'src/app/services/call-agent/call-agent.service';
import { CartService } from 'src/app/services/cart/cart.service';
import { LocationService } from 'src/app/services/location/location.service';
import { OrderService } from 'src/app/services/order/order.service';
import { ShopServiceService } from 'src/app/services/shop-service.service';
import { ThumaMinaService } from 'src/app/services/thuma-mina/thuma-mina.service';
import { UserProfileService } from 'src/app/services/user-profile/user-profile.service';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    YocoSDK: any;
  }
}

@Component({
  selector: 'app-make-order',
  templateUrl: './make-order.page.html',
  styleUrls: ['./make-order.page.scss'],
})
export class MakeOrderPage implements OnInit {
  type;

  cartItems;
  cartTotal;
  coords;
  userDetails;
  requesterID;
  address;

  isBtnClicked = false;

  paymentMethod;
  methodSelected = false;

  wallet;

  constructor(
    private orderService: OrderService,
    private locationService: LocationService,
    private cartService: CartService,
    private userProfileService: UserProfileService,
    private route: ActivatedRoute,
    private thumaMinaService: ThumaMinaService,
    private router: Router,
    private alertController: AlertController,
    private shopService: ShopServiceService,
    private callAgentService: CallAgentService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((res) => {
      this.type = res.requestType;
      this.requesterID = res.requesterID;

      if (this.type !== 'delivery-only') {
        this.requesterID = this.cartService.getRequestBy();
        this.cartItems = this.cartService.getCartItems();
        this.coords = this.locationService.getCoords();
        this.address = this.locationService.getAddress();
      }
    });
  }

  onSelectMethod(e) {
    this.paymentMethod = e.detail.value;
    this.methodSelected = true;
  }

  order() {
    if (this.type === 'delivery-only') {
      this.makeRequest();
    }
  }

  // makeOrder() {
  //   this.isBtnClicked = true;
  //   this.userProfileService
  //     .getProfile(this.requesterID)
  //     .pipe(take(1))
  //     .subscribe((res: any) => {
  //       if (res.exists) {
  //         const data = res.data();
  //         const name = data.name + ' ' + data.surname;
  //         const email = data.email;
  //         const phone = data.phone;
  //         const cartTotal = this.cartService.getCartPrice() + 20;
  //         const address = this.address;

  //         const orderObject = {
  //           cart: this.cartItems,
  //           cartTotal,
  //           location: this.coords,
  //           address,
  //           requestBy: this.requesterID,
  //           name,
  //           email,
  //           phone,
  //         };

  //         this.orderService
  //           .placeOrder(orderObject)
  //           .then(() => {
  //             this.isBtnClicked = false;
  //             alert('Order Made');
  //           })
  //           .catch((error) => {
  //             this.isBtnClicked = false;
  //             alert('Error' + JSON.stringify(error));
  //           });
  //       } else {
  //         this.isBtnClicked = false;
  //         alert('Error');
  //       }
  //     });
  // }

  makeRequest() {
    if (this.thumaMinaService.getDetails()) {
      this.isBtnClicked = true;
      this.userProfileService
        .getProfile(this.requesterID)
        .pipe(take(1))
        .subscribe((res: any) => {
          if (res.exists) {
            const data = res.data();
            const name = data.name + ' ' + data.surname;
            const email = data.email;
            const phone = data.phone;
            const details = this.thumaMinaService.getDetails();
            const store = details.store;
            const requestType = 'delivery-only';
            const paymentMethod = this.paymentMethod;

            const orderObject = {
              requestBy: this.requesterID,
              name,
              email,
              phone,
              details,
              requestType,
              paymentMethod,
              deliveryFee: details.deliveryFee,
            };

            if (paymentMethod.toLowerCase() === 'wallet') {
              this.userProfileService
                .getUserWallet(this.requesterID)
                .pipe(take(1))
                .subscribe((walletRes: any) => {
                  if (walletRes.exists) {
                    const dd = walletRes.data();
                    const rands = dd.rands;
                    if (details.deliveryFee > rands) {
                      this.isBtnClicked = false;
                      const err = 'Not enough money in Wallet.';
                      // alert(err);
                      this.presentInvalidWallet(err);
                    } else {
                      this.orderService
                        .makeRequest(orderObject)
                        .then(() => {
                          this.isBtnClicked = false;
                          alert('Order Made. Make payment to Complete Order');
                          this.notifyStore(name, store);
                          this.router.navigate(['/user-orders']);
                        })
                        .catch((error) => {
                          this.isBtnClicked = false;
                          alert(
                            'Error requesting order ' + JSON.stringify(error)
                          );
                        });
                    }
                  } else {
                    this.isBtnClicked = false;
                    const err =
                      'Error processing wallet. Check if wallet is loaded!';
                    // alert(err);
                    this.presentInvalidWallet(err);
                  }
                });
            } else {
              this.orderService
                .makeRequest(orderObject)
                .then(() => {
                  this.isBtnClicked = false;
                  let text;
                  if (paymentMethod.toLowerCase() === 'cash') {
                    text = 'You are liable for cash delivery upon request';
                  } else {
                    text = 'Order Made. Make payment to Complete Order';
                  }
                  alert(text);
                  this.router.navigate(['/user-orders']);
                })
                .catch((error) => {
                  this.isBtnClicked = false;
                  alert('Error requesting order ' + JSON.stringify(error));
                  // console.log(error);
                });
            }
          } else {
            this.isBtnClicked = false;
            alert('Error');
          }
        });
    } else {
      // console.log('undefiend');
    }
  }

  notifyStore(customerName, store) {
    store = store.toLowerCase().trim();
    console.log(`store is ${store} and customer is ${customerName}`);

    this.shopService
      .getShopProfiles()
      .pipe(take(1))
      .subscribe((res) => {
        const data = res.docs.map((store) => ({
          ...(store.data() as Object),
        }));

        console.log(data);

        if (data) {
          data.map((storeObj: any) => {
            if (storeObj.storeName.includes(store)) {
              if (storeObj.playerID) {
                console.log('store has player ID');
                const msg = `Order for ${customerName}`;
                this.callAgentService.sendNotificationToStore(
                  msg,
                  storeObj.playerID
                );
              } else {
                console.log('store has no player ID');
              }
            } else {
              console.log('# - store has no player ID');
            }
          });
        }
      });
  }

  async presentInvalidWallet(msg) {
    const alert = await this.alertController.create({
      header: 'Error',
      message: msg,
      buttons: [
        {
          text: 'Cancel',
        },
        {
          text: 'Go to Wallet',
          handler: () => {
            this.router.navigate(['/user-wallet']);
          },
        },
      ],
    });

    await alert.present();
  }
}
